import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import CalendarHeader from './CalendarHeader';
import { WeekDays } from './WeekDays';
import Days from './Days';

const DateSelectorContentWrapper = styled.div`
  margin-top: ${props => props.isClientView ? '20px' : '62px'};  
  display: ${props => props.isOpen ? 'block' : 'none'};  
  width: 340px;
  // height: 172px;
  border-radius: 3px; 
  background-color: #ffffff;
  position: ${props => props.isClientView ? 'relative' : 'absolute'};  
  left: -10px;
  z-index:1;
  &:before {
    content:'';
    width: 0;
    height: 0;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-bottom: 13px solid #f4f8f9;
    position: absolute;
    z-index: 1000;
    top: -13px;
    left: 33%;
  }

  @media(min-width: 375px) {
    width: ${props => props.isClientView ? '346px' : '355px'};  
    left: ${props => props.isClientView ? '0px' : '-12px'}; 
    &:before {
      left: 32%;
      display:none;
    }
  }

  @media(min-width: 800px) {
    margin-top: ${props => props.isClientView ? '30px' : '60px'};  
    width: ${props => props.isClientView ? '800px' : '490px'};  
    left: 0px 
    z-index: 9999;
    &:before {
      left: 34%;
      display:none;
    }
  }
`;

const DateSelectorContent = (props) => {
  return (
    <DateSelectorContentWrapper
      isOpen={props.calendarOpen}
      isClientView={props.isClient}
    >
      <CalendarHeader
        monthYear={props.monthYear}
        handlePreviousMonth={props.handlePreviousMonth}
        handleNextMonth={props.handleNextMonth}
        isClientView={props.isClient}
      />
      <WeekDays
        handlePreviousWeek={props.handlePreviousWeek}
        handleNextWeek={props.handleNextWeek}
      />
      <Days
        handlePreviousWeek={props.handlePreviousWeek}
        handleNextWeek={props.handleNextWeek}
        getWeekDays={props.getWeekDays}
        isSameDay={props.isSameDay}
        handleSelect={props.handleSelect}
        current={props.current}
        today={props.today}
        daysSelected={props.selectedDates}
        calendarFirstDate={props.calendarFirstDate}
      />
    </DateSelectorContentWrapper>
  )
};

DateSelectorContent.propTypes = {
  calendarOpen: PropTypes.bool,
  monthYear: PropTypes.string,
  handlePreviousMonth: PropTypes.func,
  handleNextMonth: PropTypes.func,
  handlePreviousWeek: PropTypes.func,
  handleNextWeek: PropTypes.func,
  getWeekDays: PropTypes.func,
  handleSelect: PropTypes.func,
  current: PropTypes.object
}

DateSelectorContent.defaultProps = {
  calendarOpen: false,
  monthYear: '',
  current: null
};

export default DateSelectorContent;


// WEBPACK FOOTER //
// ./src/components/UI/DateSelector/DateSelectorContent.js